<div class="cm-inspector-content">
    @if ($node(); as referenceFrame) {
        <cm-inspector-section>
            <ng-container cm-content>
                <cm-value-slot [node]="$node()" [key]="'name'" [label]="'Name'"></cm-value-slot>
                <cm-value-slot
                    [node]="referenceFrame"
                    [key]="'type'"
                    [label]="'Type'"
                    [selectionPossibilities]="referenceFrameTypeSelectionPossibilities"
                ></cm-value-slot>
                <cm-value-slot
                    [node]="referenceFrame"
                    [key]="'parent'"
                    [label]="'Parent'"
                    [selectionPossibilities]="$referenceFrameParentSelectionPossibilities()"
                ></cm-value-slot>
                <cm-value-slot [node]="referenceFrame" [key]="'origin'" [label]="'Origin'"></cm-value-slot>
                <cm-value-slot [node]="referenceFrame" [key]="'unit'" [label]="'Unit'"></cm-value-slot>
            </ng-container>
        </cm-inspector-section>
    }
</div>
